import goto from "src/pageDefinitions/goto";
import { SessionStorageKey } from "src/utils/constants";
import { setNoomSessionStorage } from "src/utils/noomSessionStorage";
import { ActionHandler } from ".";

/**
 * Opens clinical intake the same way checkout did: mark this session as a new
 * telehealth patient, then enter enrollment setup.
 */
export const startTelehealthEnrollment: ActionHandler = () => {
  setNoomSessionStorage(SessionStorageKey.isNewPatient, true);
  setNoomSessionStorage(SessionStorageKey.isTelehealthBuyflow, true);
  goto.telehealthEnrollmentSetup();
};
